import GeneralActionTypes from './general.types';

export const activeTabChangeStart = (activeTab: any) => ({
	type: GeneralActionTypes.ACTIVE_TAB_CHANGED,
	payload: activeTab,
});
export const isEditDetailsStart = (isEdit: any) => ({
	type: GeneralActionTypes.IS_EDIT_DETAILS_START,
	payload: isEdit,
});

export const isOpenCanvasStart = (isOpen: any) => ({
	type: GeneralActionTypes.IS_OPEN_OFFCANVAS_START,
	payload: isOpen,
});

export const isSideTabChangeStart = (siedTabChanged: any) => ({
	type: GeneralActionTypes.SIDE_TAB_VALUE_CHANGED,
	payload: siedTabChanged,
});

export const isDocumentTabBarTypeChangeStart = (tabBarType: any) => ({
	type: GeneralActionTypes.DOCUMENT_TAB_BAR_FOR_TYPE_CHANGED,
	payload: tabBarType,
});

export const isDocumentTabBarChangeStart = (isChangeImage: any) => ({
	type: GeneralActionTypes.DOCUMENT_TAB_BAR_VALUE_CHANGED,
	payload: isChangeImage,
});

/** ******************* BASIC DETAILS ******************* */
export const fatherContactVerifyChangeStart = (fatherVerify: any) => ({
	type: GeneralActionTypes.FATHER_CONTACT_VERIFY_CHANGED,
	payload: fatherVerify,
});

export const motherContactVerifyChangeStart = (motherVerify: any) => ({
	type: GeneralActionTypes.MOTHER_CONTACT_VERIFY_CHANGED,
	payload: motherVerify,
});

export const referenceOneContactVerifyChangeStart = (ref1Verify: any) => ({
	type: GeneralActionTypes.REFERENCE_ONE_CONTACT_VERIFY_CHANGED,
	payload: ref1Verify,
});

export const referencTwoContactVerifyChangeStart = (ref2Verify: any) => ({
	type: GeneralActionTypes.REFERENCE_TWO_CONTACT_VERIFY_CHANGED,
	payload: ref2Verify,
});

export const fatherPhoneCallReviewVerifyChangeStart = (reviewDetails: any) => ({
	type: GeneralActionTypes.FATHER_PHONECALL_REVIEW_VERIFY_CHANGED,
	payload: reviewDetails,
});

export const motherPhoneCallReviewVerifyChangeStart = (reviewDetails: any) => ({
	type: GeneralActionTypes.MOTHER_PHONECALL_REVIEW_VERIFY_CHANGED,
	payload: reviewDetails,
});

export const ref1PhoneCallReviewVerifyChangeStart = (reviewDetails: any) => ({
	type: GeneralActionTypes.REF1_PHONECALL_REVIEW_VERIFY_CHANGED,
	payload: reviewDetails,
});

export const ref2PhoneCallReviewVerifyChangeStart = (reviewDetails: any) => ({
	type: GeneralActionTypes.REF2_PHONECALL_REVIEW_VERIFY_CHANGED,
	payload: reviewDetails,
});

/** ******************* AADHAR VERIFY DETAILS ******************* */

export const aadharVerifyFrontImageChangeStart = (aadharNumberVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_FRONT_IMAGE_VERIFY_CHANGED,
	payload: aadharNumberVerifyed,
});

export const aadharVerifyBackImageChangeStart = (aadharNumberVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_BACK_IMAGE_VERIFY_CHANGED,
	payload: aadharNumberVerifyed,
});

export const aadharVerifyNumberChangeStart = (aadharNumberVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_NUMBER_VERIFY_CHANGED,
	payload: aadharNumberVerifyed,
});

export const aadharVerifyNameChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_NAME_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyFatherNameChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_FATHER_NAME_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyDobChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_DOB_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyCityChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_CITY_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyStateChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_STATE_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyPinCodeChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_PINCODE_VERIFY_CHANGED,
	payload: aadharVerifyed,
});

export const aadharVerifyAddressChangeStart = (aadharVerifyed: any) => ({
	type: GeneralActionTypes.AADHAR_ADDRESS_VERIFY_CHANGED,
	payload: aadharVerifyed,
});


/** ******************* EMPLOYEE VERIFY DETAILS ******************* */

export const employeeIdFrontImageVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_FRONT_IMAGE_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const employeeIdBackImageVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_BAcK_IMAGE_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const employeeIdNumberVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_NUMBER_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const employeeIdNameVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_NAME_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const employeeDesignationVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_DESIGNATION_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const employeeIdDojVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_DOJ_CHANGED,
	payload: employeeVerifyed,
});

export const nameOrganizationVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.NAME_ORGANIZATION_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const yearOrganizationVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.YEAR_ORGANIZATION_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

export const locationVerifyChangeStart = (employeeVerifyed: any) => ({
	type: GeneralActionTypes.LOCATION_VERIFY_CHANGED,
	payload: employeeVerifyed,
});

/** ******************* DRIVING LICENCE DETAILS ******************* */

export const dlFrontImageVerifyChangeStart = (dlVerifyed: any) => ({
	type: GeneralActionTypes.DL_FRONT_IMAGE_VERIFY_CHANGED,
	payload: dlVerifyed,
});

export const dlBackImageVerifyChangeStart = (dlVerifyed: any) => ({
	type: GeneralActionTypes.DL_BAcK_IMAGE_VERIFY_CHANGED,
	payload: dlVerifyed,
});

export const dlNumberVerifyChangeStart = (dlVerifyed: any) => ({
	type: GeneralActionTypes.DL_NUMBER_VERIFY_CHANGED,
	payload: dlVerifyed,
});

export const dlExpiryDateVerifyChangeStart = (dlVerifyed: any) => ({
	type: GeneralActionTypes.DL_EXPIRY_DATE_VERIFY_CHANGED,
	payload: dlVerifyed,
});

/** ******************* VOTER ID DETAILS ******************* */

export const voterIdFrontImageVerifyChangeStart = (voterIdVerifyed: any) => ({
	type: GeneralActionTypes.VOTER_ID_FRONT_IMAGE_VERIFY_CHANGED,
	payload: voterIdVerifyed,
});

export const voterIdBackImageVerifyChangeStart = (voterIdVerifyed: any) => ({
	type: GeneralActionTypes.VOTER_ID_BAcK_IMAGE_VERIFY_CHANGED,
	payload: voterIdVerifyed,
});

/** ******************* DRIVING LICENCE DETAILS ******************* */

export const passportFrontImageVerifyChangeStart = (PossportVerifyed: any) => ({
	type: GeneralActionTypes.PASSPORT_FRONT_IMAGE_VERIFY_CHANGED,
	payload: PossportVerifyed,
});

export const passportBackImageVerifyChangeStart = (PossportVerifyed: any) => ({
	type: GeneralActionTypes.PASSPORT_BAcK_IMAGE_VERIFY_CHANGED,
	payload: PossportVerifyed,
});

export const passportNumberVerifyChangeStart = (dlVerifyed: any) => ({
	type: GeneralActionTypes.PASSPORT_NUMBER_VERIFY_CHANGED,
	payload: dlVerifyed,
});

export const passportDateIssueVerifyChangeStart = (PossportVerifyed: any) => ({
	type: GeneralActionTypes.PASSPORT_DATE_ISSUE_VERIFY_CHANGED,
	payload: PossportVerifyed,
});

export const passportExpiryDateVerifyChangeStart = (PossportVerifyed: any) => ({
	type: GeneralActionTypes.PASSPORT_EXPIRY_DATE_VERIFY_CHANGED,
	payload: PossportVerifyed,
});

/** ******************* PHOTO AND VIDEOS ******************* */

export const selfieImageVerifyChangeStart = (photoVerifyed: any) => ({
	type: GeneralActionTypes.SELFIE_IMAGE_VERIFY_CHANGED,
	payload: photoVerifyed,
});

export const selfieVideoVerifyChangeStart = (photoVerifyed: any) => ({
	type: GeneralActionTypes.SELFIE_VIEOS_VERIFY_CHANGED,
	payload: photoVerifyed,
});

/** ******************* COLLEGE DETAILS ******************* */

export const collegeIdFrontImageVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.COLLEGE_ID_FRONT_IMAGE_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const collegeIdBackImageVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.COLLEGE_ID_BAcK_IMAGE_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const collegeNameVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.COLLEGE_NAME_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const streamVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.STREAM_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const selectFromYearVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.SELECT_FROM_YEAR_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const selectToYearVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.SELECT_TO_YEAR_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const courseShortFormVerifyChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.COURSE_SHORT_FORM_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const programChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.PROGRAM_CATEGARY_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const rollNumberChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.ROLL_NUMBER_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

export const markSheetChangeStart = (collegeVerifyed: any) => ({
	type: GeneralActionTypes.MARK_SHEET_VERIFY_CHANGED,
	payload: collegeVerifyed,
});

/** ******************* PAYSILIP DETAILS ******************* */

export const totalMonthlySalaryVerifyChangeStart = (salariedVerified: any) => ({
	type: GeneralActionTypes.TOTAL_MONTHLY_SALARY_VERIFY_CHANGED,
	payload: salariedVerified,
});

export const esiNumberVerifyChangeStart = (esiNumber: any) => ({
	type: GeneralActionTypes.ESI_NUMBER_VERIFY_CHANGED,
	payload: esiNumber,
});

export const payslipMonthVerifyChangeStart = (payslipMonth: any) => ({
	type: GeneralActionTypes.PAYSLIP_MONTH_VERIFY_CHANGED,
	payload: payslipMonth,
});

export const pfDeductionChangeStart = (pfDeduction: any) => ({
	type: GeneralActionTypes.PF_DEDUCTION_VERIFY_CHANGED,
	payload: pfDeduction,
});

export const payslipDocumetVerifyChangeStart = (payslipDoc: any) => ({
	type: GeneralActionTypes.PAYSLIP_DOCUMENT_VERIFY_CHANGED,
	payload: payslipDoc,
});

/** ******************* BANK STATEMENT DETAILS ******************* */

export const bankStatementVerifyChangeStart = (bankDetailsVerifyed: any) => ({
	type: GeneralActionTypes.BANK_STATEMENT_VERIFY_CHANGED,
	payload: bankDetailsVerifyed,
});

/** ******************* PANCARD DETAILS ******************* */

export const pancardImageChangeStart = (pancardVerifyed: any) => ({
	type: GeneralActionTypes.PANCARD_IMAGE_VERIFY_CHANGED,
	payload: pancardVerifyed,
});

export const pancardNumberVerifyChangeStart = (pancardVerifyed: any) => ({
	type: GeneralActionTypes.PANCARD_NUMBER_VERIFY_CHANGED,
	payload: pancardVerifyed,
});

/** ******************* DOC DETAILS ******************* */

export const allMachedVerifyChangeStart = (allVerifyed: any) => ({
	type: GeneralActionTypes.ALL_MACHED_VERIFY_CHANGED,
	payload: allVerifyed,
});

export const isPhoneCallAttendChangeStart = (phonecallVerifyed: any) => ({
	type: GeneralActionTypes.IS_PHONECALL_ATTEND_VERIFY_CHENGED,
	payload: phonecallVerifyed,
});

/** *******************ALL DETAILS VERIFY ******************* */

export const basicDetailsVerifyChangeStart = (basicVerified: any) => ({
	type: GeneralActionTypes.BASIC_DETAILS_VERIFY_CHANGED,
	payload: basicVerified,
});

export const aadharDetailsVerifyChangeStart = (aadharVerified: any) => ({
	type: GeneralActionTypes.AADHAR_DETAILS_VERIFY_CHENGED,
	payload: aadharVerified,
});

export const collegeDetailsVerifyChangeStart = (collegeVerified: any) => ({
	type: GeneralActionTypes.COLLEGE_DETAILS_VERIFY_CHANGED,
	payload: collegeVerified,
});

export const employeeDetailsVerifyChangeStart = (employeeIDVerified: any) => ({
	type: GeneralActionTypes.EMPLOYEE_DETAILS_VERIFY_CHENGED,
	payload: employeeIDVerified,
});
export const payslipDetailsVerifyChangeStart = (payslipVerified: any) => ({
	type: GeneralActionTypes.PAYSLIP_DETAILS_VERIFY_CHANGED,
	payload: payslipVerified,
});

export const pancardDetailsVerifyChangeStart = (pancardVerified: any) => ({
	type: GeneralActionTypes.PANCARD_DETAILS_VERIFY_CHENGED,
	payload: pancardVerified,
});
export const drivingLicenceDetailsVerifyChangeStart = (dlVerified: any) => ({
	type: GeneralActionTypes.DRIVINGLICENCE_VERIFY_CHANGED,
	payload: dlVerified,
});

export const voterIdDetailsVerifyChangeStart = (voterVerified: any) => ({
	type: GeneralActionTypes.VOTERID_DETAILS_VERIFY_CHENGED,
	payload: voterVerified,
});
export const passportDetailsVerifyChangeStart = (passportVerified: any) => ({
	type: GeneralActionTypes.PASSPORT_DETAILS_VERIFY_CHANGED,
	payload: passportVerified,
});

export const photoVideoVerifyChangeStart = (photoAndVideoVerified: any) => ({
	type: GeneralActionTypes.PHOTO_VIDEO_VERIFY_CHENGED,
	payload: photoAndVideoVerified,
});

export const bankDetailsVerifyChangeStart = (bankVerified: any) => ({
	type: GeneralActionTypes.BANK_DETAILS_VERIFY_CHANGED,
	payload: bankVerified,
});

// REVIEW
export const allDocMatchReviewChangeStart = (allDocReview: any) => ({
	type: GeneralActionTypes.ALL_DOC_MATCH_REVIEW_CHANGED,
	payload: allDocReview,
});

export const phoneCallReviewChangeStart = (phoneCallReview: any) => ({
	type: GeneralActionTypes.PHONE_CALL_REVIEW_CHANGED,
	payload: phoneCallReview,
});

export const basicReviewChangeStart = (basicReview: any) => ({
	type: GeneralActionTypes.BASIC_REVIEW_CHANGED,
	payload: basicReview,
});

export const aadharReviewChangeStart = (aadharReview: any) => ({
	type: GeneralActionTypes.AADHAR_REVIEW_CHANGED,
	payload: aadharReview,
});

export const panReviewChangeStart = (panReview: any) => ({
	type: GeneralActionTypes.PAN_REVIEW_CHANGED,
	payload: panReview,
});

export const collegeReviewChangeStart = (collegeReview: any) => ({
	type: GeneralActionTypes.COLLEGE_REVIEW_CHANGED,
	payload: collegeReview,
});

export const employeeIDReviewChangeStart = (employeeIDReview: any) => ({
	type: GeneralActionTypes.EMPLOYEE_ID_REVIEW_CHANGED,
	payload: employeeIDReview,
});

export const payslipReviewChangeStart = (payslipReview: any) => ({
	type: GeneralActionTypes.PAYSLIP_REVIEW_CHANGED,
	payload: payslipReview,
});

export const drivingLicenceReviewChangeStart = (drivingLicenceReview: any) => ({
	type: GeneralActionTypes.DRIVING_LICENCE_REVIEW_CHANGED,
	payload: drivingLicenceReview,
});

export const passportReviewChangeStart = (passportReview: any) => ({
	type: GeneralActionTypes.PASSPORT_REVIEW_CHANGED,
	payload: passportReview,
});

export const voterIDReviewChangeStart = (voterIDReview: any) => ({
	type: GeneralActionTypes.VOTER_ID_REVIEW_CHANGED,
	payload: voterIDReview,
});

export const photoAndVideoReviewChangeStart = (photoAndVideoReview: any) => ({
	type: GeneralActionTypes.PHOTO_VIDEO_REVIEW_CHANGED,
	payload: photoAndVideoReview,
});

export const bankReviewChangeStart = (bankReview: any) => ({
	type: GeneralActionTypes.BANK_REVIEW_CHANGED,
	payload: bankReview,
});


